<template>
  <div class="select_sending_range">
    <div>
      <span
        v-show="!defaultSelectedIds.length && !openUserid.length"
        class="handle_text"
        @click="showSendingRange = !showSendingRange"
      >
        {{ title }}
      </span>
      <div v-show="defaultSelectedIds.length || openUserid.length">
        已选择发送范围
        <span class="handle_text" @click="showSendingRange = !showSendingRange">修改</span>
      </div>
    </div>
    <div class="select_range_box" v-show="showSendingRange">
      <div class="tree_box">
        <div class="input_box">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="mini"></el-input>
        </div>
        <div class="tree_scroll custom_scroll_bar">
          <el-tree
            :data="treeList"
            show-checkbox
            node-key="id"
            ref="tree"
            highlight-current
            @check="checkTree"
            :props="treeProps"
            :filter-node-method="filterNode"
          ></el-tree>
        </div>
      </div>
      <div class="result">
        <div class="result_title">已选择的成员、部门</div>
        <div class="select_list custom_scroll_bar">
          <span v-for="(item, index) in selectList" :key="index">
            {{ item.name }}
            <i class="el-icon-close" @click="delSelectResult(index)"></i>
          </span>
        </div>
        <div class="btn_col">
          <el-button
            class="item_left"
            :disabled="Boolean(filterText)"
            type="text"
            @click="checkedAll"
          >
            {{ isAll ? '取消全选' : ' 全选' }}
          </el-button>
          <el-button class="item_rigth" size="mini" type="primary" @click="confirm">确定</el-button>
          <el-button class="item_rigth" size="mini" @click="cancel">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GetWeComDepartmentListApi, SearchWeComUserListApi } from '@/api/addressList';
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      filterText: '',
      treeList: [],
      selectList: [],
      selectListBak: [], // 备份默认选中的值
      isAll: false,
      showSendingRange: false,
      // props
      treeProps: {
        label: 'name',
        isLeaf: 'leaf',
      },
      disabled: false,
      openUserid: [], // 结果id
      defaultData: {}, // 默认值对象
      defaultSelectedIds: [], // 默认值id
    };
  },
  watch: {
    // 全选 反选
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.getWeComDepartmentList();
  },
  methods: {
    // 设置默认值
    setDefaultValue(obj) {
      this.defaultData = obj;
    },
    // 查找
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 删除选择
    delSelectResult(index) {
      console.log(this.selectListBak, 'selectListBak');
      this.selectList.splice(index, 1);
      this.$refs.tree.setCheckedNodes(this.selectList);
      // 更新不是全选的状态
      this.judgmentIsAllCheck();
    },
    // 查询所有用户
    async searchWeComUserList(cb) {
      const form = {
        department_id: 0,
        fetch_child: 1,
        limit: 999999,
      };
      await SearchWeComUserListApi(form)
        .then((res) => {
          if (cb) {
            cb(res.userlist);
          }
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    // 取消
    cancel() {
      this.showSendingRange = false;
      // 如果有提交记录就恢复到提交记录
      console.log(this.selectListBak);
      console.log(this.openUserid, 'openUserid');
      if (this.openUserid.length) {
        // 如果之前缓存是全选 那就用selectlistBak 因为有一些是部门是空部门
        // openUserId 只保存用户的id, 全选用openuser会导致空部门选不上
        if (this.selectListBak[0] && this.selectListBak[0].id == 1) {
          this.$refs.tree.setCheckedNodes(this.selectListBak);
        } else {
          this.$refs.tree.setCheckedNodes(this.openUserid);
        }
        this.selectList = this.selectListBak.concat([]);
      } else if (this.defaultSelectedIds.length) {
        // 如果有设置默认项则恢复默认项
        this.$refs.tree.setCheckedKeys(this.defaultSelectedIds);
        this.selectList = this.selectListBak.concat([]);
      } else {
        this.selectList = [];
        this.openUserid = [];
        this.$emit('confirm', this.openUserid);
        this.$refs.tree.setCheckedNodes([]);
      }
      this.filterText = null;
    },
    getDepartmentIntoUser(arr) {
      let openUserid = [];
      let defaultSelectedIds = [];
      arr.forEach((e) => {
        if (e.children && !e.userid) {
          // 这是一个部门
          const selcetData = this.getDepartmentIntoUser(e.children);
          openUserid = selcetData.openUserid.concat(openUserid);
          defaultSelectedIds = selcetData.defaultSelectedIds.concat(defaultSelectedIds);
        } else if (e.userid) {
          // 这是一个员工
          openUserid.push(e);
          defaultSelectedIds.push(e.id);
        } else if (e.id) {
          // 这是一个空的部门
          defaultSelectedIds.push(e.id);
        }
      });
      return {
        openUserid,
        defaultSelectedIds,
      };
    },
    // 确认
    confirm() {
      const selcetData = this.getDepartmentIntoUser(this.selectList);
      this.openUserid = selcetData.openUserid;
      this.defaultSelectedIds = selcetData.defaultSelectedIds;
      this.selectListBak = this.selectList.concat([]);
      this.$emit('confirm', this.openUserid);
      this.showSendingRange = false;
    },
    // 判断是否达到全选
    judgmentIsAllCheck() {
      if (this.selectList.length == this.treeList.length) {
        let flag = true;
        for (let i = 0; i < this.treeList.length; i++) {
          const item = this.treeList[i];
          const findRes = this.selectList.find((cloneItem) => {
            return cloneItem.id == item.id;
          });
          if (!findRes) {
            flag = false;
            break;
          }
        }
        return flag;
      }
    },
    // 全选与反选
    checkedAll() {
      if (!this.isAll) {
        this.$refs.tree.setCheckedNodes(this.treeList);
        this.$nextTick(() => {
          const selectList = [];
          this.treeList.forEach((e) => {
            selectList.push(e);
          });
          this.selectList = selectList;
        });
      } else {
        this.$refs.tree.setCheckedNodes([]);
        this.selectList = [];
      }
      this.isAll = !this.isAll;
    },
    // 点击的回调
    checkTree() {
      let selectList = [];
      // 过滤出结果
      this.treeList.forEach((e) => {
        const node = this.$refs.tree.getNode(e);
        selectList = selectList.concat(this.filterChildrenCheck(node));
      });
      this.selectList = selectList.map((e) => e.data);
      // 判断是否达到全选
      this.isAll = this.judgmentIsAllCheck();
    },
    // 递归把节点是选中都扁平化数组
    filterChildrenCheck(node) {
      let result = [];
      if (node.checked) {
        result.push(node);
      } else {
        if (Array.isArray(node.childNodes)) {
          node.childNodes.forEach((item) => {
            result = result.concat(this.filterChildrenCheck(item));
          });
        }
      }
      return result;
    },
    // 反扁平化
    treeListDeep(arr) {
      const result = [];
      for (let i = 0; i < arr.length; i++) {
        const sItem = arr[i];
        let flag = true;
        for (let k = 0; k < arr.length; k++) {
          const pItem = arr[k];
          if (sItem.parentid == pItem.id) {
            flag = false;
            if (pItem.children) {
              pItem.children.push(sItem);
            } else {
              pItem.children = [sItem];
            }
            break;
          }
        }
        if (flag) {
          result.push(sItem);
        }
      }
      return result;
    },
    // 把员工插入部门
    getDepartmentInUser(departmentList) {
      return new Promise((resolve) => {
        // 插入值 参数： 目标 值 key
        function insertData(target, value, key) {
          if (target[key]) {
            target[key].push(value);
          } else {
            target[key] = [value];
          }
        }

        this.searchWeComUserList((list) => {
          // 员工对象
          const employeeData = {};
          // 默认选择的用户id
          const defaultSelectedIds = [];
          // 选择的用户list
          const selectList = [];
          list.forEach((item) => {
            const keys = item.department_id.split(',');
            // 防止有人在多个部门，然后进行处理
            keys.forEach((k, i) => {
              let value = item;
              if (i) {
                value = Object.assign({}, item);
              }
              value.leaf = true;
              value.id = value.userid + Math.random().toString(36).substr(2, 5) + i;
              if (this.defaultData[value.userid]) {
                // 找到了默认选中的用户
                defaultSelectedIds.push(value.id);
                selectList.push(value);
              }
              // 插入操作
              insertData(employeeData, value, k);
            });
          });
          departmentList.forEach((e) => {
            if (employeeData[e.id]) {
              //  找到了 插入的时候 格式一下数据
              e.children = employeeData[e.id];
            }
          });
          // 备份处理
          this.$refs.tree.setCheckedKeys(defaultSelectedIds);
          this.defaultSelectedIds = defaultSelectedIds;
          this.selectListBak = selectList.concat([]);
          this.selectList = selectList;
          resolve(departmentList);
        });
      });
    },
    getWeComDepartmentList() {
      GetWeComDepartmentListApi()
        .then((res) => {
          this.getDepartmentInUser(res.department).then((treeList) => {
            this.treeList = this.treeListDeep(treeList);
          });
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
